import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const ProtectedRoute = ({ children, allowedRoles }) => {
  const { accessToken, getRoleFromToken, loading } = useAuth();
  
  if (loading) {
    return <div>Loading...</div>; 
  }


  // If not logged in
  if (!accessToken) {
    return <Navigate to="/" replace />;
  }

  // Get role securely from JWT
  const role = getRoleFromToken(accessToken);
  


  // If route is restricted by role
  if (allowedRoles && !allowedRoles.includes(role)) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default ProtectedRoute;